<template>
  <div>
    <div class="">
      <div>
        <h5 class="vue-title pull-left custom-header" >
          <strong>提携先カテゴリーマスタ一覧</strong>
        </h5>
        <p class="float-right btn-add-category" >
          {{ $t("ADD") }}
          <a href="#/addcategory">
            <em class="fas fa-plus-circle"></em>
          </a>
        </p>
        <b-input-group 
          class="pull-right search-box-cat"
        >
          <template v-slot:prepend>
            <b-input-group-text>
              <em class="fa fa-search"></em>
            </b-input-group-text>
          </template>
          <b-form-input size="sm"></b-form-input>
        </b-input-group>
      </div>
      <c-table
        :table-data="caregory"
        :fields="fields"
        :per-page="10"
        striped
        hover
        :total="10"
        :edit="edit"
        :delete="delet"
      ></c-table>

      <b-modal id="modal-delete" hide-footer>
        <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}</template>
        <p class="my-4">
          「クリニック」提携先マスターを削除しますがよろしいですか？
        </p>
        <hr />
        <b-row>
          <b-col>
        
            <b-button
              variant="danger"
              class="buttons-align-right"
              block
              @click="$bvModal.hide('modal-delete')"
              >{{ $t("DELETE") }}</b-button
            >
         

      
            <b-button
              block
              class="buttons-align-right"
              @click="$bvModal.hide('modal-delete')"
              >{{ $t("CLOSE") }}</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { CATEGORY_LIST } from "@/store/actions.type";
import { mapGetters } from "vuex";
import cTable from "@/components/Table.vue";

export default {
  name: "categoryList",
  data() {
    return {};
  },
  tableData: [],
  computed: {
    ...mapGetters(["caregory"])
  },
  components: { cTable },
  methods: {
    delet(id) {
      this.$bvModal.show("modal-delete");
    },
    edit(id) {
      this.$router.push("/addcategory");
    }
  },
  created() {
      this.$toast.removeAll();
    this.$store.dispatch(CATEGORY_LIST);
    this.fields = [
      { key: "ID", label: this.$t("ID"), sortable: true,class:"text-left" },
      {
        key: "提携先カテゴリー名",
        label: "提携先カテゴリー名",
        sortable: true,
        class:"text-left"
      },
      { key: "ステータス", label: "ステータス ", sortable: true },

      { key: "actions", label: "アクション", sortable: true }
    ];
  }
};
</script>
<style>
.btn-add-category{
font-size: 17px;    margin-top: 14px
}
.search-box-cat{
  width:200px;margin:10px 20px;height:10px
}
</style>
